import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { changeSidebarTheme, changeTopbarTheme, changeSidebarThemeImage } from '../../store/actions';

// Layout Related Components
import Header from './Header';
import Sidebar from './Sidebar';
// import MySnow from '../../components/ui/snow';
// import Footer from './Footer';

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
    };
    this.toggleMenuCallback = this.toggleMenuCallback.bind(this);
  }

  componentDidMount() {
    // Scroll Top to 0
    window.scrollTo(0, 0);
    document.body.classList.add('vertical-collpsed');
    document.body.classList.add('sidebar-enable');
    // if (this.props.leftSideBarTheme) {
    //   this.props.changeSidebarTheme(this.props.leftSideBarTheme);
    // }
    if (this.props.leftSideBarThemeImage) {
      this.props.changeSidebarThemeImage(this.props.leftSideBarThemeImage);
    }
    // if (this.props.topbarTheme) {
    //   this.props.changeTopbarTheme(this.props.topbarTheme)
    // }
  }
  toggleMenuCallback = () => {
    var body = document.body;
    body.classList.toggle('vertical-collpsed');
    body.classList.toggle('sidebar-enable');
  };

  render() {
    return (
      <React.Fragment>
        <div id='layout-wrapper'>
          {/* <MySnow snowflakeCount={300} radius={[10.0, 20.0]}/> */}
          <Header toggleMenuCallback={this.toggleMenuCallback} props={this.props} profileData={this.props.children.props.profileData} />
          <Sidebar
            theme='winter'
            type='default'
            // theme={this.props.leftSideBarTheme}
            // type={this.props.leftSideBarType}
            isMobile={this.state.isMobile}
            // classList="vertical-collpsed sidebar-enable"
            profileData={this.props.children.props.profileData}
          />
          <div className='main-content'>{this.props.children}</div>
          {/* <Footer /> */}
        </div>
      </React.Fragment>
    );
  }
}

Layout.propTypes = {
  changeSidebarTheme: PropTypes.func,
  changeSidebarThemeImage: PropTypes.func,
  children: PropTypes.any,
  leftSideBarTheme: PropTypes.any,
  leftSideBarThemeImage: PropTypes.any,
  changeTopbarTheme: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    ...state.Layout
  };
};
export default connect(mapStateToProps, {
  changeSidebarTheme,
  changeSidebarThemeImage,
  changeTopbarTheme
})(withRouter(Layout));
